/**
 * Содержит информацию для создания новых задач
 */
export class JobCreate {
  /**
   * Тип задачи
   */
  public jobType?: string;

  /**
   * Название задачи
   */
  public jobName: string;

  /**
   * Группа, к которой задача принадлежит
   */
  public jobGroup: string;

  /**
   * Параметры задачи (JSON в виде строки)
   */
  public parameters?: string;

  /**
   * Время следующего выполнения
   */
  public firstRunningDateTime?: Date;

  /**
   * Интервал выполнения
   */
  public jobInterval?: string;

  /**
   * Определяет, запретить ли одновременный запуск задачи
   */
  public concurrentExecutionDisallowed?: boolean = true;
}



// WEBPACK FOOTER //
// ./src/app/core/models/storedJob/jobCreate.model.ts